// Vuex connections module mutations

import {
  FILL_LIST,
  SET_FILTERING_CRITERIA,
  SET_PAGE,
  UPDATE_NUMBER,
  REMOVE_NUMBER,
} from './mutations-types';

export default {
  [UPDATE_NUMBER](state, payload) {
    const _state = state;

    const updatedElementId = payload.number_id;
    const { params } = payload;

    _state.list.records = _state.list.records.map(element => (element.id === updatedElementId
      ? { ...element, ...params }
      : element));
  },
  [REMOVE_NUMBER](state, payload) {
    const _state = state;

    const removedElementId = payload.number_id;

    _state.list.records = _state.list.records.filter(element => element.id !== removedElementId);
  },
  [FILL_LIST](state, payload) {
    const _state = state;
    _state.list.records = payload.records;
    _state.list.total = payload.total;
  },
  [SET_FILTERING_CRITERIA](state, payload) {
    const _state = state;
    _state.filteringCriteria = payload;
  },
  [SET_PAGE](state, payload) {
    const _state = state;
    _state.list.page = payload.page;
  },
};
